import React from "react";
import LazyImg from "../lazy/lazy";
import "./imageView.css"

const ImageView = (props)=>
{
return(
    <div className="shows-img">
    <LazyImg src={props.src} className="w-100" alt="" orient={"landscape"} ></LazyImg>
</div>
);
}

export default ImageView;